import { kBiRollingUnitLabels } from '@euler/app/components/message/widgets/bi-visualization/functions/biTimeRangeLabel';
import {
  BiTimeGrain,
  BiTimeRange,
  BiTimeRangeKind,
  kBiMaxRollingCount,
} from '@euler/model/bi/query';
import dayjs from 'dayjs';

/** What a range typed into the picker came to. */
export type BiRangeInput =
  | { kind: 'ok'; range: BiTimeRange }
  /** Not finished typing: nothing to say yet. */
  | { kind: 'empty' }
  | { kind: 'invalid'; problem: string };

/** Longest absolute range the server takes, in days. */
const kMaxAbsoluteDays = 3660;

/** "最近 N 个单位", the count capped per unit as the server caps it. */
export function biRollingInput(
  countText: string,
  unit: BiTimeGrain,
  includeCurrent: boolean,
): BiRangeInput {
  const text = countText.trim();
  if (!text) return { kind: 'empty' };
  const count = Number(text);
  const max = kBiMaxRollingCount[unit];
  if (!/^\d+$/.test(text) || count < 1)
    return { kind: 'invalid', problem: '请输入一个正整数' };
  if (count > max)
    return {
      kind: 'invalid',
      problem: `最多 ${max} ${kBiRollingUnitLabels[unit]}`,
    };
  return {
    kind: 'ok',
    range: { kind: BiTimeRangeKind.Rolling, unit, count, includeCurrent },
  };
}

function isDate(text: string): boolean {
  return (
    /^\d{4}-\d{2}-\d{2}$/.test(text) &&
    dayjs(text).format('YYYY-MM-DD') === text
  );
}

/** Two named dates, inclusive: for "1 月到 3 月", never for "最近". */
export function biAbsoluteInput(
  fromText: string,
  toText: string,
): BiRangeInput {
  const from = fromText.trim();
  const to = toText.trim();
  if (!from || !to) return { kind: 'empty' };
  if (!isDate(from) || !isDate(to))
    return { kind: 'invalid', problem: '日期格式为 2026-01-31' };
  if (from > to)
    return { kind: 'invalid', problem: '开始日期不能晚于结束日期' };
  if (dayjs(to).diff(dayjs(from), 'day') + 1 > kMaxAbsoluteDays)
    return { kind: 'invalid', problem: '时间跨度最多十年' };
  return { kind: 'ok', range: { kind: BiTimeRangeKind.Absolute, from, to } };
}
